import {
  combineReducers,
  configureStore,
  createSerializableStateInvariantMiddleware,
} from "@reduxjs/toolkit";
import audioReducer from "./features/audioSlice";
import globalReducer from "./features/globalSlice";
import scenesReducer from "./features/scenesSlice";
import thunk from "redux-thunk";

const reducer = combineReducers({
  global: globalReducer,
  scenes: scenesReducer,
  audio: audioReducer,
});
export const store = configureStore({
  reducer,
  middleware: [thunk],
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
